<template>
  <aside class="course-lessons-list row">
    <div class="col-lg-3 col-md-6 py-3" v-for="(lesson, i) in lessons" :key="i">
      <router-link
        class="text-decoration-none text-light align-items-center"
        :to="{
          name: 'lesson',
          params: {
            ...course,
            lesson: lesson.id,
            id: courseId
          }
        }"
      >
        <div
          class="img"
          :src="picture(lesson)"
          :style="`background-image: url(${picture(lesson)})`"
        />

        <div class="d-flex align-items-center">
          <div class="flex-fill pr-2">
            <h6>{{ lesson.name }}</h6>
          </div>

          <div
            v-if="lesson.progress && lesson.progress.finished_at"
            class="circle check"
          >
            <img src="https://img.icons8.com/metro/16/FFFFFF/checkmark.png" />
          </div>
        </div>
      </router-link>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true
    },
    courseId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      searchTerm: ""
    };
  },
  computed: {
    lessons() {
      return this.course.lessons.filter(
        item =>
          item.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    }
  },
  methods: {
    picture(lesson) {
      return lesson.picture;
      // || this.course.cover
    },
    duration(lesson) {
      if (!lesson.duration) return "";
      let [h, m, s] = lesson.duration.split(":");
      if (h === "00") {
        return `${m}:${s}`;
      } else {
        return lesson.duration;
      }
    },
    chunk(text, size) {
      // text formatation
      let tags = [
        ["<p>&nbsp;</p>", ""],
        ["<br />", ""],
        ["<p>&ZeroWidthSpace;</p>", ""],
        ["<p>", ""],
        ["</p>", "<br />"]
      ];
      tags.forEach(tag => {
        while (true) {
          if (text.includes(tag[0])) {
            text = text.replace(tag[0], tag[1]);
          } else {
            break;
          }
        }
      });
      // text chunk
      if (text.length < size) return text;
      return text.substring(0, size) + "...";
    }
  }
};
</script>

<style lang="scss" scoped>
.course-lessons-list {
  .img {
    height: 0;
    width: 100%;
    display: block;
    padding-bottom: 55%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    margin-bottom: 8px;
  }

  a {
    display: block;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  .circle {
    min-width: 24px;
    min-height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
    }
  }
  .check {
    background: #04c56b;
  }

  .badge {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    background: rgba(255, 255, 255, 0.2);
    color: white;
  }

  p {
    font-size: 14px;
    line-height: 16px;
  }
}
</style>
